// Module
var code = ` <ul class="nav nav-tabs"> <li ng-class="{'active': fs_navigation_tab === 'create_new_ticket'}"> <a ui-sref="app.acct-feedsupport({account_id: account_id})">Create Ticket</a> </li> <li ng-class="{'active': fs_navigation_tab === 'tickets' && fs_ticket_number==''}"> <a href="{{feedSupportTicketsLink}}">Tickets</a> </li> </ul> `;
// Exports
module.exports = code;